import styled from 'styled-components';
import { Form } from '@unform/web';

interface ITabProps {
  active?: boolean;
}

export const Tabs = styled.div`
  display: flex;
  gap: 12px;
  margin: 24px 0;
  border-bottom: 2px solid #ddd;
`;

export const Tab = styled.button<ITabProps>`
  padding: 12px 20px;
  font-size: 16px;
  background: transparent;
  border: none;
  border-bottom: 3px solid
    ${({ active }) => (active ? '#7284ff' : 'transparent')};
  color: ${({ active }) => (active ? '#000' : '#666')};
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};

  &:hover {
    color: #000;
  }
`;

export const Container = styled.div`
  padding: 0 20px 40px;

  table {
    width: 100%;
    border-spacing: 0;
    margin-top: 24px;
  }

  table th {
    font-size: 22px;
    text-align: left;
    font-weight: 400;
    background: #f1f1f1;

    padding: 10px;

    & + th {
      border-left: 1px solid #ddd;
    }
  }

  table td {
    font-size: 16px;
    padding: 10px;
  }

  table tr:nth-child(even) td {
    background: #f5f5f5;
  }

  table th:last-child,
  table td:last-child {
    text-align: right;
  }
`;

export const Filters = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;

  margin-top: 24px;

  button {
    display: flex;
    align-items: center;
    height: 45px;

    border: 1px solid transparent;
    padding: 0 16px;
    background: #e1e1e1;
    cursor: pointer;

    &:first-child {
      color: #fff;
      border-color: #7284ff;
      background: #7284ff;
    }

    &:hover,
    &:active {
      border-bottom-color: #ccc;
    }

    &[disabled] {
      cursor: default;
    }
  }

  svg {
    margin-right: 8px;
  }
`;

export const FiltersWrapper = styled(Form)`
  display: flex;
  align-items: end;
  gap: 8px;
`;

export const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  color: #333;
  font-size: 22px;
  background: #f5f5f5;
  padding: 50px 0;
  border-radius: 0 0 8px 8px;
`;

export const Wrapper = styled.div`
  display: flex;

  color: #666;
  margin-top: 24px;
  padding: 12px 32px;

  section {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      width: 100%;
      padding: 0 42px;
    }

    & + section div {
      border-left: 1px solid #efefef;
    }
  }

  strong {
    display: block;

    font-size: 52px;
    font-weight: 700;
  }
`;

export const ContainerCircle = styled.div`
  position: relative;
  display: inline-block;

  margin-right: 24px;

  svg circle:nth-child(2) {
    animation: circle-chart-fill 2s reverse;
    transform: rotate(-87deg);
    transform-origin: center;
  }

  svg + svg {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
  }

  @keyframes circle-chart-fill {
    to {
      stroke-dasharray: 0 100;
    }
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f6c866;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background: #e5b855;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  svg {
    margin-right: 4px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin: 36px 0;
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  min-height: 80vh;
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    h2 {
      margin: 0;
      font-size: 20px;
    }

    button {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #999;

      &:hover {
        color: #666;
      }
    }
  }
`;
